export const templateAssignmentKeys = {
  all: ['template-assignments'] as const,
  forProduct: (productId: string) => [...templateAssignmentKeys.all, 'product', productId] as const,
  coverage: (productIds: string[]) => [...templateAssignmentKeys.all, 'coverage', [...productIds].sort()] as const,
};
